// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3wuU6","title":"Header_title__2iPkn","left":"Header_left__29pn9","clinicName":"Header_clinicName__EHLBu"};